import router from './router'

export default {
	moduleName: 'file',
	router
}



// WEBPACK FOOTER //
// ./src/core/modules/file/index.js